// extracted by mini-css-extract-plugin
export var links = "navSection-module--links--c23a3";
export var mainWrapper = "navSection-module--mainWrapper--15d12";
export var mainWrapperMobile = "navSection-module--mainWrapperMobile--26147";
export var title = "navSection-module--title--06a04";